import { defaultFillsGraphConfiguration } from './FillsGraphConfiguration';
import State from 'store/State';
import { selectFillsGraphState } from '../selectors';
import { useSelector } from 'react-redux';
import { useWidgetContext } from 'widgets/WidgetContext';
import cloneDeep from 'lodash/cloneDeep';

export const selectFillsGraphConfiguration = (
    state: State,
    fillsGraphId: string
) => {
    const fillsGraphState = selectFillsGraphState(state, fillsGraphId);
    return fillsGraphState && fillsGraphState.config
        ? fillsGraphState.config
        : cloneDeep(defaultFillsGraphConfiguration);
};

export const useFillsGraphConfigurationSelector = () => {
    const { widgetKey } = useWidgetContext();
    return useSelector((state: State) =>
        selectFillsGraphConfiguration(state, widgetKey)
    );
};
